module.exports = __webpack_public_path__ + "img/lake-cabin.6ea81705.webp";